export enum Buttons {
    Okay,
    OkayCancel,
    YesCancel
}

export enum Button {
    Okay,
    Cancel,
    Yes
}

export enum MessageType {
    Success,
    Error,
    Info
}